import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import {
    Paper,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import axios from 'src/utils/axios';
import { Grid, IconButton, makeStyles } from '@material-ui/core';
import moment from 'moment';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Skeleton from '@mui/material/Skeleton';

const useStyles = makeStyles({
    tableHead: {
        fontWeight: 'bold',
        borderLeft: '1px solid #ddd',
    },
    tableRow: {
        borderLeft: '1px solid #ddd',
    }
});

function ReceiptCustomerDetail() {

    const { CustomerNo } = useParams();
    const history = useHistory();
    const classes = useStyles();

    const [customerReceiptsData, setCustomerReceiptsData] = React.useState([]);
    const [loading, setLoading] = React.useState(true);

    useEffect(() => {
        getCustomerAllReceiptsInformation();
    }, []);

    const getCustomerAllReceiptsInformation = () => {
        axios.get(`GetCustomerAllReceiptsInformation/${CustomerNo}`)
            .then((response) => {
                var customerData = response.data;
                setCustomerReceiptsData(customerData);
                setLoading(false);
            }).catch((error) => {
                setLoading(false);
            });
    }

    const handleGoBack = () => {
        history.goBack();
    };

    const RouteReceiptDetailPage = (ReceiptNumber) => {
        history.push(`/SarisQueries/ReceiptDetails/${ReceiptNumber}`);
    }

    return (
        <Grid container spacing={1} style={{ overflow: 'auto', maxHeight: '90vh' }}>
            <Grid item xs={false} sm={false} md={2} />
            <Grid item xs={12} sm={12} md={8}>
                <Paper elevation={3} style={{ marginTop: 20 }}>
                    <TableContainer component={Paper}>
                        <Table size='small'>
                            <TableHead>
                                <TableRow style={{ backgroundColor: '#0033a0', color: '#fff' }}>
                                    <TableCell colSpan={6}>
                                        <Grid container alignItems="center">
                                            <Grid item xs={1}>
                                                <IconButton onClick={() => { handleGoBack(); }} style={{ color: '#fff' }}>
                                                    <ArrowBackIcon />
                                                </IconButton>
                                            </Grid>
                                            <Grid item xs={10}>
                                                <Typography variant="h5" align="center" style={{ color: '#fff' }}>
                                                    Müşteri Fiş Bilgileri
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={1} />
                                        </Grid>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        align='left'
                                        style={{
                                            border: '1px solid #ddd',
                                            fontSize: '1rem',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        Fiş No
                                    </TableCell>
                                    <TableCell
                                        align='left'
                                        style={{
                                            border: '1px solid #ddd',
                                            fontSize: '1rem',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        Servis
                                    </TableCell>
                                    <TableCell
                                        align='left'
                                        style={{
                                            border: '1px solid #ddd',
                                            fontSize: '1rem',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        Çağrı Tarihi
                                    </TableCell>
                                    <TableCell
                                        align='left'
                                        style={{
                                            border: '1px solid #ddd',
                                            fontSize: '1rem',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        İşlem Tarihi
                                    </TableCell>
                                    <TableCell
                                        align='left'
                                        style={{
                                            border: '1px solid #ddd',
                                            fontSize: '1rem',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        Ürün
                                    </TableCell>
                                    <TableCell
                                        align='left'
                                        style={{
                                            border: '1px solid #ddd',
                                            fontSize: '1rem',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        Başvuru Nedeni
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {loading ? (
                                    Array.from(new Array(3)).map((_, index) => (
                                        <TableRow key={index}>
                                            {Array.from(new Array(6)).map((_, cellIndex) => (
                                                <TableCell key={cellIndex} colSpan={1}>
                                                    <Skeleton animation="pulse" variant="text" width={150} />
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))
                                ) : (
                                    customerReceiptsData.length > 0 && customerReceiptsData.map((customer, index) => (
                                        <TableRow key={index}>
                                            <TableCell
                                                align='left'
                                                style={{
                                                    border: '1px solid #ddd'
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        textDecoration: 'underline',
                                                        cursor: 'pointer',
                                                        color: '#4C3BCF'
                                                    }}
                                                    onClick={() => { RouteReceiptDetailPage(customer.FIS_NO); }}
                                                >
                                                    {customer.FIS_NO}
                                                </span>
                                            </TableCell>
                                            <TableCell align='left' style={{ borderRight: '1px solid #ddd' }}>{customer.KUL_BIRIM_KODU}</TableCell>
                                            <TableCell align='left' style={{ borderRight: '1px solid #ddd' }}>{moment(customer.CAGRI_TARIHI).format('DD-MM-YYYY HH:mm:ss')}</TableCell>
                                            <TableCell align='left' style={{ borderRight: '1px solid #ddd' }}>{moment(customer.ISLEM_TARIHI).format('DD-MM-YYYY HH:mm:ss')}</TableCell>
                                            <TableCell align='left' style={{ borderRight: '1px solid #ddd' }}>{customer.ACIKLAMA}</TableCell>
                                            <TableCell align='left' style={{ borderRight: '1px solid #ddd' }}>{customer.BASVURU_NEDENI}</TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </Grid>
            <Grid item xs={false} sm={false} md={2} />
        </Grid>
    )
}

export default ReceiptCustomerDetail